import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=07d9ddf0&scoped=true&"
import script from "./OverviewCard.vue?vue&type=script&lang=ts&"
export * from "./OverviewCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9ddf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem})
